import React, { forwardRef } from 'react';
import { format, parseISO } from 'date-fns';

const DatePicker = forwardRef(({
  selected,
  onChange,
  minDate,
  maxDate,
  className = '',
  ...props
}, ref) => {
  // Convert Date object to YYYY-MM-DD string for input value
  const formattedValue = selected ? format(selected, 'yyyy-MM-dd') : '';

  // Handle change: convert YYYY-MM-DD string back to Date object
  const handleChange = (e) => {
    if (!e.target.value) {
      onChange(null);
      return;
    }
    // Create date object from the input string (which is in local time representation)
    // We use new Date(string) or parseISO. 
    // new Date('2023-01-01') usually creates UTC date or Local date depending on browser/implementation.
    // Let's use straightforward new Date(e.target.value) which usually treats YYYY-MM-DD as UTC, 
    // BUT <input type="date"> works in local time visual.
    
    // Better approach to preserve "selected day":
    const [year, month, day] = e.target.value.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    onChange(date);
  };

  const minStr = minDate ? format(minDate, 'yyyy-MM-dd') : undefined;
  const maxStr = maxDate ? format(maxDate, 'yyyy-MM-dd') : undefined;

  return (
    <div className={className}>
      <input
        ref={ref}
        type="date"
        className="input-field w-full"
        value={formattedValue}
        onChange={handleChange}
        min={minStr}
        max={maxStr}
        {...props}
      />
    </div>
  );
});

DatePicker.displayName = 'DatePicker';

export default DatePicker;
